import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Contractor } from 'model/Contractor';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import ConfirmResultModal from 'component/part/ConfirmResultModal';
import H2 from 'component/part/H2';

const ContractorShow: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const contractorId = parseInt(urlParams.id || '');
  const [contractor, setContractor] = useState<Contractor>();
  const [confirm, setConfirm] = useState(false);

  const onSubmit = async () => {
    if (!contractor) return false;
    const result = await api.contractor.delete(contractor.id);

    return result.ok && !!result.data?.result;
  };

  useEffect(() => {
    (async () => {
      if (contractorId) {
        const contractorResponse = await api.contractor.get(contractorId);
        if (contractorResponse) {
          setContractor(contractorResponse);
        }
      }
    })();
  }, [contractorId]);

  return <Layout>
    <BackLink link='/contractor/list' label='元請情報一覧'></BackLink>
    <H2>業者情報</H2>
    <div css={generalStyle.form}>
      <FormContent label='元請名'>
        <div css={generalStyle.item()}>{contractor?.name || ''}</div>
      </FormContent>
      {contractor && (
        <div css={generalStyle.formRow}>
          <NavLink to={`/contractor/${contractor.id}/edit`} css={generalStyle.button()}>編集</NavLink>
          <button onClick={() => setConfirm(true)} css={generalStyle.button('warning')}>削除</button>
        </div>
      )}
    </div>
    <ConfirmResultModal
      display={confirm}
      onHide={() => setConfirm(false)}
      onSubmit={onSubmit}
      onOk={() => navigate('/contractor/list')}
      objectType='contractor'
      operationType='delete'
    />
  </Layout>;
};

export default ContractorShow;
